import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=0835288a"
import script from "./SideCart.vue?vue&type=script&lang=js"
export * from "./SideCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports